import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingHeaderFullscreenGalleryHeaderProps {
  favourite: React.ReactNode;
  newbuildingName: string | null;
  call: React.ReactNode;
}

export const NewbuildingHeaderFullscreenGalleryHeader: React.FC<INewbuildingHeaderFullscreenGalleryHeaderProps> = ({
  newbuildingName,
  favourite,
  call,
}) => {
  return (
    <div className={styles['container']}>
      <div className={styles['main']}>
        {newbuildingName && <UIText2 color="text-inverted-default">{newbuildingName}</UIText2>}
      </div>
      <div className={styles['aside']}>
        <div className={styles['call']}>{call}</div>
        {favourite}
      </div>
    </div>
  );
};
